export default __webpack_public_path__ + "static/media/course-2.7b441567.png";